module.exports = __webpack_public_path__ + "img/default-new.5ad6988d.png";